import { render } from "./PrivacyRulesComponent.vue?vue&type=template&id=456dde2e&scoped=true"
import script from "./PrivacyRulesComponent.vue?vue&type=script&lang=js"
export * from "./PrivacyRulesComponent.vue?vue&type=script&lang=js"

import "./PrivacyRulesComponent.vue?vue&type=style&index=0&id=456dde2e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456dde2e"]])

export default __exports__